import algoliasearch from "algoliasearch"
const client = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
)
const algoliaIndex = client.initIndex(process.env.GATSBY_ALGOLIA_INDEX_NAME)

export default algoliaIndex
